import { supabase } from '@/lib/supabase';

export type ReportType = 'broken_link' | 'incorrect_info' | 'other';
export type ReportStatus = 'pending' | 'resolved';

export interface ReportRow {
  id: string;
  user_id: string;
  item_id: number;
  report_type: ReportType;
  status: ReportStatus;
  description: string | null;
  created_at: string;
  resolved_at: string | null;
  resolved_by: string | null;
}

export const getReports = async (status?: ReportStatus): Promise<ReportRow[]> => {
  let query = supabase
    .from('reports')
    .select('*')
    .order('created_at', { ascending: false });

  if (status) {
    query = query.eq('status', status);
  }

  const { data, error } = await query;
  if (error) throw error;
  return (data || []) as ReportRow[];
};

export const setReportStatus = async (id: string, status: ReportStatus): Promise<ReportRow> => {
  const { data: { user } } = await supabase.auth.getUser();

  const payload: Record<string, unknown> = { status };
  if (status === 'resolved') {
    payload.resolved_at = new Date().toISOString();
    payload.resolved_by = user?.id ?? null;
  } else {
    payload.resolved_at = null;
    payload.resolved_by = null;
  }

  const { data, error } = await supabase
    .from('reports')
    .update(payload)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data as ReportRow;
};

export const deleteReport = async (id: string): Promise<void> => {
  const { error } = await supabase.from('reports').delete().eq('id', id);
  if (error) throw error;
};

